import { Field as FormikField, FieldAttributes } from 'formik';
import { IFormik } from '@broadleaf/admin-components/dist/types/form';
import useFormatMessage from '@broadleaf/admin-components/dist/common/hooks/useFormatMessage';
import { get } from 'lodash';
import { IMetadataFieldComponent } from '@broadleaf/admin-components/dist/types/metadata';
import cx from 'classnames';
import { FieldDecorations } from '@broadleaf/admin-components/dist/form/helpers/FieldDecorations';
import { useFormatNumber } from '@broadleaf/admin-components/dist/common';
import React from 'react';
import MinMaxInput from '@src/components/form/inputs/MinMaxInput';

export type InputFieldProps = FieldAttributes<any> & {
  name: string;
  className?: string;
  inputClassName?: string;
  formik: IFormik;
  isDisabled?: boolean;
  min?: number;
  max?: number;
  showMin?: boolean;
  showMax?: boolean;
  tooltip?: string;
  fullWidth?: boolean;
  label: string;
  hint?: string;
  type?: string;
};
export const InputField = ({
  className = '',
  inputClassName = '',
  formik,
  name,
  isDisabled,
  label,
  type = 'text',
  tooltip,
  hint,
  ...props
}: InputFieldProps) => {
  const formatMessage = useFormatMessage();
  const error = get(formik.errors, name);
  const touched = get(formik.touched, name);
  const showError = !!touched && !!error;
  const metadata = {
    label: label,
    tooltip,
    hint,
    required: props.required
  } as IMetadataFieldComponent;
  return (
    <div className="tw-flex-1">
      <div
        className={cx(
          className,
          'tw-flex tw-items-center tw-justify-end tw-whitespace-nowrap',
          'tw-flex-initial tw-self-end tw-px-3 lg:tw-mt-1 lg:tw-self-start lg:tw-px-0'
        )}
      >
        <FieldDecorations
          formik={formik}
          metadata={metadata}
          fullWidth={props.fullWidth}
        >
          <FormikField
            {...props}
            className={cx(
              inputClassName,
              'tw-mr-1 tw-flex tw-flex-1 tw-rounded tw-border tw-border-gray-300 tw-px-2 tw-py-1'
            )}
            name={name}
            disabled={formik.isSubmitting || isDisabled}
            showError={showError}
            type={type}
            component={MinMaxInput}
          />
        </FieldDecorations>
      </div>
    </div>
  );
};
